import type { VoiceDto } from '../../data/dto/voice.dto.ts'
import type { Voice } from '../models/voice.ts'
import { getFlagEmojiFromCountryCode } from '@/utils/get-flag-emoji-from-country-code.ts'

export const mapVoiceDtoToVoice = (voice: VoiceDto): Voice => ({
  id: voice.alias,
  name: voice.alias.replace(/_/g, ' '),
  provider: voice.provider,
  isExpressive: voice.provider === 'elevenlabs',
  accent: voice.accent,
  tags: voice.tags,
  language: voice.language,
  languageCode: voice.languageCode.split('-')[1]?.toUpperCase() ?? '',
  flag: getFlagEmojiFromCountryCode(voice.languageCode) ?? '',
  picture: voice.picture,
  audioSampleUrl: voice.audioSample,
  hasTTS: voice.meta.technologies.includes('TTS'),
  hasSTS: voice.meta.technologies.includes('STS'),
})
